export default {"src":"/_next/static/media/XRAY.1e0f42c1.svg","height":18,"width":18};